// packages
import cx from 'classnames';
import { capfirst, intcomma } from 'journalize';
import { Component, h } from 'preact';
import { PreactHTMLConverter } from 'preact-html-converter';



// internal
import { sort_candidates_by_party, changePartyName } from '../election-utils';

type Props = {
  contest: { [key: string]: any };
  columnCount: number;
  contestTitle: string;
  renderParty: any;
  matchingFlag: { [key: string]: any };
  matchingNote: { [key: string]: any };
  visibleCandidatesCount?: number;
};

const converter = PreactHTMLConverter();

class Ballots extends Component<Props> {
  render() {
    const {
      contest,
      columnCount,
      contestTitle,
      matchingFlag,
      matchingNote,
      renderParty,
    } = this.props;


    let get_races = contest.values;

    let each_party = get_races.map((candidate: any) => candidate);


    const IsFlagged = (matchingFlag[0]) ? true : false;

    const IsNoted= (matchingNote[0]) ? true : false;


    const rowClass = cx('seat__title', {
        'flagged': IsFlagged == true,
      });
   

    return (
      <div class="seat">
        {IsFlagged == true && (
          <div class="seat__flag">
            <span class="office__flag">
              <span class="gold-star">★</span>Race to watch
            </span>
            <h3 class={rowClass}>
              {contestTitle}
              <a
                  href={`https://www.texastribune.org/directory/districts/${get_races[0].values[0].directory_slug}/${get_races[0].values[0].district}`}
                  title="Click to learn more about this district"
            >
                <span class="icon-div">
                  <svg class="icon icon-info">
                <use xlinkHref="#icon-info"></use>
                  </svg>
               </span>
           </a>
            </h3>
            <p class="seat__flag__text">
              {converter.convert(matchingFlag[1].value)}
            </p>
          </div>
        )}
        {IsFlagged == false && (
          <h3 class={rowClass}>
            {contestTitle}
            <a
              href={`https://www.texastribune.org/directory/districts/${get_races[0].values[0].directory_slug}/${get_races[0].values[0].district}`}
              title="Click to learn more about this district"
            >
              <span class="icon-div">
                <svg class="icon icon-info">
            <use xlinkHref="#icon-info"></use>
                </svg>
              </span>
            </a>
          </h3>
        )}

        <div class="seat__races">
          {each_party.map((party: any) => renderParty(party))}
        </div>

        {IsNoted == true && (
          <p class="note__text">{converter.convert(matchingNote[1].value)}</p>
        )}
      </div>
    );
  }
}

Ballots.defaultProps = {
  visibleCandidatesCount: 3,
  columnCount: 2,
};

export default Ballots;
